'use strict';

let messages_it = {

  "HEADER": {
    "LOGOUT": "Esci"
  },

  "EXAMPLES": {
    "TODO_LIST.VISIBILITY_FILTER": {
      "SHOW_ALL": "Tutti",
      "SHOW_COMPLETED": "Completati",
      "SHOW_ACTIVE": "Da fare"
    },
  },
  "FECON_ISAC": {
    "FUN_ACCOUNT": {
      "TITLE": "Account"
    },
    "FUN_LOGIN": {
      "TITLE": "Accesso"
    },
    "FUN_PWGONE": {
      "TITLE": "Recupero credenziali"
    },
    "FUN_PWLOCK": {
      "TITLE": "Recupero credenziali"
    },
    "FUN_PWFORGOT": {
      "TITLE": "Recupero credenziali"
    },
    "FUN_SECINFO": {
      "TITLE": "Informazioni di Sicurezza"
    },
    "FUN_FORCEEMAIL": {
      "TITLE": "Recupero credenziali"
    }
  },
  "LOGIN_PAGE": {
    "TITLE": {
      "BLOCK0": "InfoCert",
      "BLOCK1": "Il futuro digitale è adesso."
    },
    "ASSISTANCE": "Assistenza",
    "UNSUPPORTED_BROWSER": {
      "BLOCK0": "Stai usando un browser",
      "BLOCK1": "non supportato",
      "BLOCK2": "Per favore",
      "BLOCK3": "aggiorna il tuo browser",
      "BLOCK4": "per migliorare la sicurezza e l'esperienza d'uso."
    },
    "CAN_NOT_ACCESS": "Non riesco ad accedere",
    "BTN_LOGIN": "Accedi",
    "FORM_LOGIN": {
      "USERNAME": {
        "LABEL": "UserID",
        "ERROR_INVALID": "Indica una user valida per l'accesso"
      },
      "PASSWORD": {
        "LABEL": "Password",
        "ERROR_PASSWORD_REQUIRED": "Per poter accedere, devi fornire una password"
      }
    },
    "ERROR_LOGIN_FAILED": "Autenticazione fallita"
  }
};

export default messages_it;



// WEBPACK FOOTER //
// ./client/app/i18n/messages_it.js